import { selectUserId } from "domain/auth/auth.selectors";
import { PropsWithChildren, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";
import { CustomTooltip } from "ui/pages/app/components/CustomTooltip";
import { CustomTextTooltip } from "ui/pages/app/components/CustomTextTooltip";
import { selectOnBoardingValues } from "domain/on-boarding/on-boarding.selectors";
import { updateOnBoardingValue } from "ui/utils/on-boarding-storage";

export const DownloadActivityImagesTooltip = ({
  children,
  activity,
}: PropsWithChildren<{ activity: "technique" | "seance" }>) => {
  const dispatch = useAppDispatch();
  const onBoardingValues = useAppSelector(selectOnBoardingValues);
  const userId = useAppSelector(selectUserId);

  const closeDownloadActivityImagesTooltip = () => {
    if (!onBoardingValues.closedDownloadActivityImages) {
      updateOnBoardingValue(userId, "closedDownloadActivityImages", dispatch);
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", closeDownloadActivityImagesTooltip);
    return () => {
      closeDownloadActivityImagesTooltip();
    };
  }, []); //eslint-disable-line

  return onBoardingValues.closedDownloadActivityImages ? (
    <CustomTextTooltip
      text={translate("ns1:Activities.Tooltips.DownloadImages")}
    >
      {children}
    </CustomTextTooltip>
  ) : (
    <CustomTooltip
      open
      onClose={closeDownloadActivityImagesTooltip}
      title={translate("ns1:OnBoarding.Tooltips.DownloadActivityImagesTitle")}
      text={translate(
        `ns1:OnBoarding.Tooltips.${
          activity === "technique"
            ? "DownloadTechniqueImagesText"
            : "DownloadSeanceImagesText"
        }`
      )}
    >
      {children}
    </CustomTooltip>
  );
};
